'use strict';

import reportingPage from './reporting.vue';
import reportingConfigPage from './reporting-config.vue';
import { reporting as reportingPageIndex } from '@enums/page-index';
import { displayReporting } from '@enums/feature-flags';

const routes = [
  {
    path: '/reporting',
    name: 'reportingConfig',
    id: 'reportingConfig',
    component: reportingConfigPage,
    index: reportingPageIndex,
    linkText: 'linkText.reporting',
    meta: {
      featureFlag: displayReporting,
      title: 'tabText.reporting',
    },
  },
  // Results route (state via query params)
  {
    path: '/reporting/view',
    name: 'reportingView',
    id: 'reportingView',
    component: reportingPage,
    omitFromNav: true,
    meta: {
      featureFlag: displayReporting,
      // Validates at least 1 workpackage is selected (works for single or multiple)
      selectedWorkpackageRequired: true,
      title: 'tabText.reportingView',
    },
  },
];

export default routes;
